import { BrowserView, MobileView, TabletView } from 'components/DeviceDetect'
import React, { useState, useEffect, useRef } from 'react'
import useProduct from 'store/SingleProductProvider'
import ProductAttributes from '../ProductAttributes'
import {
  DesktopProductImages,
  MobileProductImages,
} from '../ProductImages/ProductImages'
import ProductMeta from '../ProductMeta'
import ProductPrice from '../ProductPrice'
import { ProductRightPane, BuyProductFooter } from '../ProductRightPane'
import ProductVariants from '../ProductVariants'
import {
  ProductHead,
  ProductInfo,
  ProductZoomedImageDiv,
} from './MainInfo.style'

export function useOnScreen(ref, options) {
  const [isIntersecting, setIntersecting] = useState(false)

  const observer = new IntersectionObserver(
    ([entry]) => setIntersecting(entry.isIntersecting),
    options
  )

  useEffect(() => {
    if (typeof ref.current !== 'undefined')
      try {
        observer.observe(ref.current)
      } catch {}
    // Remove the observer as soon as the component is unmounted
    return () => {
      observer.disconnect()
    }
  }, [observer, ref])

  return isIntersecting
}

const Head = props => {
  const [showFooter, setShowFooter] = useState(true)

  const ref = useRef()
  const imageRef = useRef()
  const buyButtonRef = useRef()
  const isVisible = useOnScreen(ref, { rootMargin: '-106px 0px' })
  const isImageVisible = useOnScreen(imageRef, {})

  useEffect(() => {
    // setShowFooter(!isVisible && !isImageVisible)
  }, [isVisible, isImageVisible])

  useEffect(() => {
    window.buyButtonRef = buyButtonRef
  }, [])

  return (
    <ProductHead>
      <BrowserView>
        <DesktopProductImages type="desktop" />
        <ProductInfo>
          <ProductZoomedImageDiv id="primage" />
          <ProductMeta Browser />

          <ProductPrice Browser />
          <ProductVariants />
          <CredoBankPrice />
          <ProductAttributes />
        </ProductInfo>

        <div>
          <ProductRightPane />
        </div>
      </BrowserView>

      <MobileView>
        <ProductInfo ref={imageRef}>
          <ProductMeta />
          <MobileProductImages type="mobile" />
          <ProductPrice />
          <CredoBankPrice />
          <ProductVariants />
        </ProductInfo>

        <div
          id="ProductRightPaneMobile"
          ref={buyButtonRef}
          style={{
            display: 'block',
            position: 'relative',
            top: '-120px',
            visibility: ' hidden',
          }}
        />
        <div ref={ref}>
          <ProductRightPane mobile={true} />
        </div>

        {showFooter && <BuyProductFooter onClick={() => setShowFooter(true)} />}
        <ProductAttributes />
      </MobileView>

      <TabletView>
        <ProductInfo>
          <ProductMeta />
          <DesktopProductImages type="desktop" />
          <CredoBankPrice />
          <ProductVariants />
        </ProductInfo>

        <ProductRightPane mobile={true} />
        <ProductAttributes />
      </TabletView>
    </ProductHead>
  )
}

const CredoBankPrice = () => {
  const {
    product: { credo_price },
  } = useProduct()

  if (!credo_price) return null

  return (
    <div
      style={{
        order: 2,
        display: 'flex',
        fontWeight: 'inherit',
        border: '2px solid #E51E0F',
        borderRadius: 8,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 20,
      }}
    >
      <img
        style={{ display: 'flex', marginTop: '10px', marginBottom: '10px' }}
        src="/img/credo.jpg"
        alt=""
      />
      <p
        style={{
          fontSize: '18px',
          fontFamily: 'Firago-Medium',
          textAlign: 'center',
          color: '#000000',
        }}
      >
        კრედო ბანკის განვადებით <br />
        <span
          style={{
            fontSize: '27px',
            fontFamily: 'Firago-Medium',
            fontWeight: 'bold',
            color: '#1e90ff',
          }}
        >
          {credo_price}₾
        </span>
      </p>
    </div>
  )
}

export default Head
